import { IGetPayoutFacetsResponse } from "@shared/lib/types/briefCampains";
import {
  getPayoutTabCount,
  PAYOUTS_TABS,
  PayoutsTab,
} from "../../lib/payoutTabs";
import styles from "./styles.module.scss";

type PayoutsStatusTabsProps = {
  activeTab: PayoutsTab;
  onChange: (tab: PayoutsTab) => void;
  facets?: IGetPayoutFacetsResponse;
};

export function PayoutsStatusTabs({
  activeTab,
  onChange,
  facets,
}: PayoutsStatusTabsProps) {
  if (!facets) return null;
  return (
    <div className={styles.wrap}>
      <nav className={styles.tabList} aria-label="Payout status">
        {PAYOUTS_TABS.map((tab) => {
          const isActive = activeTab === tab;
          return (
            <button
              key={tab}
              type="button"
              aria-current={isActive ? "true" : undefined}
              className={`${styles.tabButton} ${
                isActive ? styles.tabButtonActive : ""
              }`}
              onClick={() => onChange(tab)}
            >
              {tab}
              <span className={styles.count}>
                {getPayoutTabCount(tab, facets)}
              </span>
            </button>
          );
        })}
      </nav>
    </div>
  );
}
